/* lsa-fp-rail: the featured-product "Thumbnails in a left column" gallery, styled
   as the PDP's vertical rail (lsa-pdp-thumbs in sections/main-product.liquid).
   Injects up/down arrows around the thumbnail list, scrolls it two thumbnails
   per click, and disables an arrow at its end (both when nothing overflows).
   Clicking a thumbnail still activates it via media-gallery.js. */
if (!customElements.get('lsa-fp-rail')) {
  customElements.define(
    'lsa-fp-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('.thumbnail-slider');
        this.list = this.querySelector('.thumbnail-list');
        if (!this.slider || !this.list || this.up) return;

        this.up = this._makeNav('up');
        this.down = this._makeNav('down');
        this.slider.insertBefore(this.up, this.slider.firstChild);
        this.slider.appendChild(this.down);

        this.up.addEventListener('click', () => this._scroll(-1));
        this.down.addEventListener('click', () => this._scroll(1));
        this._onScroll = () => this._update();
        this.list.addEventListener('scroll', this._onScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => this._update());
          this._ro.observe(this.list);
          this._ro.observe(this.slider);
        }
        window.addEventListener('resize', this._onScroll, { passive: true });

        /* Thumbnails lazy-load, so the list may not overflow yet on first run. */
        this.list.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', this._onScroll, { once: true });
          img.addEventListener('error', this._onScroll, { once: true });
        });
        [0, 250, 750, 1500].forEach((t) => setTimeout(() => this._update(), t));
      }

      disconnectedCallback() {
        this._ro && this._ro.disconnect();
        window.removeEventListener('resize', this._onScroll);
      }

      _makeNav(dir) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lsa-fp-rail__nav lsa-fp-rail__nav--' + dir;
        b.setAttribute('aria-label', dir === 'up' ? 'Scroll thumbnails up' : 'Scroll thumbnails down');
        const d = dir === 'up' ? 'M2 7.5 6 3.5 10 7.5' : 'M2 4.5 6 8.5 10 4.5';
        b.innerHTML =
          '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="' +
          d +
          '" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return b;
      }

      _scroll(direction) {
        const item = this.list.querySelector('.thumbnail-list__item');
        const gap = parseFloat(getComputedStyle(this.list).rowGap || getComputedStyle(this.list).gap) || 0;
        const step = (item ? item.getBoundingClientRect().height + gap : 80) * 2;
        this.list.scrollBy({ top: step * direction, behavior: 'smooth' });
      }

      _update() {
        const max = this.list.scrollHeight - this.list.clientHeight;
        const epsilon = 2;
        this.up.disabled = this.list.scrollTop <= epsilon;
        this.down.disabled = this.list.scrollTop >= max - epsilon;
      }
    }
  );
}
